import { render, staticRenderFns } from "./white-label-create-modal.vue?vue&type=template&id=4f1fc401&scoped=true&"
import script from "./white-label-create-modal.vue?vue&type=script&lang=js&"
export * from "./white-label-create-modal.vue?vue&type=script&lang=js&"
import style0 from "./white-label-create-modal.vue?vue&type=style&index=0&id=4f1fc401&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1fc401",
  null
  
)

export default component.exports